import { render, staticRenderFns } from "./TheInstitute.vue?vue&type=template&id=2c070dc6"
var script = {}
import style0 from "./TheInstitute.vue?vue&type=style&index=0&id=2c070dc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_oo5wulyvj3zulgczlh6g6gwe5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports